<template>
  <div style="overflow: hidden;">
    <v-layout
      class="inner-pages"
      column
      :style="{height: $store.getters.getAppHeight + 'px'}">


    <v-flex class="sfh-login-header text-xs-center pa-1">
      <v-layout row align-center justify-center style="justify-content: space-between;">
        <div
          id="leftHeaderId"
          class="px-2"
          style="display:flex;"
          :class="currentStep === 1 ? 'current-step' : ''">
          <transition name="slide-fade">
            <img
              v-if="display"
              @click.stop="$store.commit('toggleLeftDrawer', true)"
              height="35"
              width="35"
              :alt="appShortName"
              style="cursor:pointer;"
              :src="levelHeaderImage(currentLevel)"
            />
          </transition>
        </div>
        <v-flex >
          <transition name="slide-fade">
          <h2
            v-if="display"
            class="white--text font-weight-regular  line-height-1"
            style="text-align: left;">
            <span style="font-size:16px;" v-text="currentLevelName"/>
          </h2>
          </transition>
        </v-flex>
        <v-flex sm4 xs5 text-xs-right>

          <v-btn fab color="transparent" @click.stop="$store.commit('toggleRightDrawer', true)"
                 class="elevation-2 mr-0" style="width:42px;height:42px;z-index: 1;">

            <div class="user-avatar elevation-10"
                 :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"
            />

          </v-btn>
          <v-toolbar-side-icon
            class="ml-0"
           :class="currentStep === 2?'current-step':''"
           dark id="rightDrawerIcon"
           @click.stop="$store.commit('toggleRightDrawer', true)"
          />
        </v-flex>
      </v-layout>

      <navigation-menu />
      <v-navigation-drawer
        dark temporary
        v-model="leftDrawer"
        app
        class="secondary lighten-5"
      >
        <v-flex class="gutter-mobile-header white" />

        <v-layout row space-between align-center>
          <v-flex text-xs-left>
            <v-btn @click="goToHome" color="primary" flat small>← Home</v-btn>
          </v-flex>
        </v-layout>

        <v-list class="secondary lighten-3 pa-0">

          <v-list-group
            v-for="(level, index) in navigationData"
            :key="'level_'+index"
            class="left_nav learn-nav blue-grey darken-4"
            style="border-bottom: 1px solid #bebebe!important;border-top: 1px solid #9c9c9c!important;"
            append-icon="expand_more"
            :value="currentLevel === level.level_number"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile class="level-list " ripple>
                <v-list-tile-avatar size="45px">
                  <img :alt="`Level ${level.level_number}`" :src="levelImage(level.level_number)" />
                </v-list-tile-avatar>
                <v-list-tile-title style="font-weight: bold;font-size: medium;"
                                   class="body-2"
                                   :title="level.name"
                                   v-text="level.name"></v-list-tile-title>
              </v-list-tile>
            </template>

            <div :key="'card_'+cindex"
                 v-for="(card, cindex) in level.cards">
              <v-list
                v-if="card.views.length === 1"
                class="pa-0"
                style="border-bottom: 1px solid grey;"
              >
                <v-list-tile
                  active-class="blue--text subheading"
                  :to="{name: 'Learn', params: {groupId, level: level.level_number, deckId, viewCount: card.views[0].viewCount}}"
                  class="blue-grey darken-3 card-list"
                >
                  <v-list-tile-avatar>

                    <img style="border-radius: 5px;"
                         alt="card"
                         :src="getCardImage(card.views[0])" />
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title
                      v-text="card.name" />
                  </v-list-tile-content>

                  <v-list-tile-action v-if="typeof group.viewsViewed !== 'undefined' &&
                  group.viewsViewed.includes(card.views[0].view_id) === true">
                    <v-icon color="light-green accent-4">done</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>

              <v-list-group
                v-else
                sub-group
                :value="isCardActive(card)"
                :class="isCardActive(card)?'card-is-active':''"
                no-action
                append-icon="none"
                style="border-bottom: 1px solid grey;"
              >
                <template v-slot:activator>
                  <v-list-tile class="blue-grey darken-3  card-list">
                    <v-list-tile-avatar>
                      <v-img style="border-radius: 5px;"
                             lazy-src="static/images/cards.png"
                             :src="getCardImage(card.views[0])">
                      </v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-title v-text="card.name"></v-list-tile-title>
                    <v-list-tile-action>
                      <v-icon class="card-expand-icon" style="font-size:24px;">arrow_drop_down</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                </template>
                <v-list class="pa-0" dense>
                  <v-list-tile
                    active-class="blue--text subheading"
                    style="border-color: #424242 !important"
                    class="view-list grey darken-4"
                    v-for="(view, i) in card.views"
                    :key="i"
                    :to="{name: 'Learn', params: {groupId, level: level.level_number, deckId, viewCount: view.viewCount}}"
                  >
                    <v-list-tile-title  v-text="view.title"></v-list-tile-title>
                    <v-list-tile-action v-if="typeof group.viewsViewed !== 'undefined' &&
                    group.viewsViewed.includes(view.view_id) === true">
                      <v-icon color="light-green accent-4">done</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-list-group>
            </div>


          </v-list-group>

        </v-list>
      </v-navigation-drawer>
    </v-flex>


    <!--- LEARN HEADER END---->

<!--    <learn-header></learn-header>-->

    <v-flex id="scroll-target"
            class="sfh-login-form background-image ">
      <v-layout column>
        <v-flex  >
          <v-layout row wrap >

            <v-layout row wrap align-center justify-center >
              <v-flex xs12 >
                <v-container class="pa-0">
                  <v-layout >
                    <div id="text-content-title" :style="learnTourStyleObj()"></div>
                    <div id="right-nav-tour-coin" :style="rightNavTourCoinObj()"></div>
                    <v-flex text-xs-center >
                      <v-stepper v-model="e1" v-if="views.length > 0">

                        <v-stepper-items>
                          <v-stepper-content
                            class="pa-0"
                            v-touch="{
                              left: () => swipe('Left'),
                              right: () => swipe('Right')
                            }"
                            :step="view.viewCount"
                            v-if="view.viewCount < (e1 + 2) && view.viewCount > (e1 - 2)"
                            v-for="(view,index) in  views" :key="'view_'+index">

                            <v-img class="grey lighten-3 view-resource"
                                   contain
                                   :height="imageHeight" transition="fade-transition"
                                   :src="apiUrl+'/ws/playerservice'+view.imageResource.resourceurl">
                              <template v-slot:placeholder>
                                <v-layout
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>

                                </v-layout>
                              </template>
                              <v-layout row align-center justify-center>
                                <v-flex
                                  class="label bottom wrapword white--text pa-2 font-weight-bold"
                                  v-if="showImageCaption"
                                >
                                  {{view.imageResource.caption === null ? view.title : view.imageResource.caption}}
                                </v-flex>
                                <v-flex style="text-align:right;" @click="openCitation(view)"
                                        class="label bottom-right wrapword white--text pa-2">
                                  <v-icon color="#fff" class="mt-1">info</v-icon></v-flex>
                              </v-layout>
                            </v-img>


                            <v-flex text-xs-left grey lighten-3
                                      style="display: flex;"
                                     class="font-weight-light">
                              <div class="pl-2 py-1">
                                <span
                                  @click.stop="$store.commit('toggleLeftDrawer', true)"
                                  class=" blue--text font-weight-regular"
                                  style="cursor: pointer;"
                                  v-text="getCardDetails(view.card_id,view.level).name"
                                />
                                <v-icon
                                  class="grey--text"
                                  style="font-size: 16px;">play_arrow</v-icon>

                                <span
                                  class="grey--text text--darken-2"
                                  v-text="view.title"/>
                              </div>
                              <v-spacer></v-spacer>
                              <div
                                class="mx-1 layout align-center justify-end"
                                style="width:100px;"
                                v-text="getViewPaging(view.card_id, view.view_id,view.level)"
                              />
                            </v-flex>
                            <v-flex text-xs-left pa-3
                                    class="textContentStyleObject scrollbar scroll-style-15"
                                    :style="textContentStyleObject()"
                                    v-html="view.textResource.textcontent"></v-flex>
                          </v-stepper-content>
                          <v-layout style="width:100%" row class="nav-btn pa-0" >
                            <!------------------------------------>
<!--                            <button @click="toggleShow">-->
<!--                            <span >coin earned!</span>-->
<!--                            </button>-->
                            <transition
                              name="ballmove">
                              <div v-if="isShowing">
                                <app-child class="child"></app-child>
                              </div>
                            </transition>
                            <script type="text/x-template" id="childarea">
                              <div class="ball"></div>
                            </script>
                            <!------------------------------------>
                            <v-flex xs6 class="text-xs-left stepper-left-button carousel-stepper-button" >
                              <v-btn  color="grey darken-1" v-if="isChevronLeft && e1 !== 1" class="elevation-5" @click.prevent="prevSlide" fab small dark>
                                <v-icon  x-large >chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs6 class="text-xs-right carousel-stepper-button">
                              <v-btn color="grey darken-1" v-if="views.length !== e1" class="elevation-5"
                                     @click.prevent="nextSlide" fab small dark>
                                <v-icon x-large >chevron_right</v-icon>
                              </v-btn>
                            </v-flex>


                          </v-layout>
                        </v-stepper-items>
                      </v-stepper>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>


            <v-dialog
              v-model="citationDialog"
              :width="$store.getters.getAppWidth - 10"
              max-width="400px"
            >
              <v-card>
                <!-- <div class="panel-footer" >Responsible food handler behaviors</div> -->
                <div class="panel-heading" >{{citationViewName}}</div>
                <v-card-text>
                  <dl class="dl-horizontal">
                    <dt>Image Title</dt>
                    <dd>{{citationImageTitle ? citationImageTitle : 'N/A'}}</dd>

                    <dt>Image Note</dt>
                    <dd>{{citationImageNote ? citationImageNote : 'N/A'}}</dd>

                    <dt>Description Note</dt>
                    <dd>{{citationDescriptionNote ? citationDescriptionNote : 'N/A'}}</dd>
                  </dl>
                </v-card-text>

              </v-card>
            </v-dialog>

          </v-layout>
        </v-flex>
      </v-layout>

    </v-flex>

    <v-tour name="learnTour" :callbacks="myCallbacks" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          />
        </transition>
      </template>
    </v-tour>
    <div id="overlay" :class="currentStep === -1?'d-none':'d-block'"></div>

  </v-layout>
  </div>

</template>

<script>
import Vue from 'vue'
import CoinEarned from './CoinEarned'
import NoScrollData from '../NoScrollData'
import VueTour from 'vue-tour'
import NavigationMenu from '../layouts/NavigationMenu'
import PlainToolbar from '../layouts/PlainToolbar'

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

function toTimestamp (strDate) {
  let datum = Date.parse(strDate)
  return datum / 1000
}
const Child = {
  template: '#childarea'
}

export default {
  name: 'Learn',
  components: {NavigationMenu, PlainToolbar, NoScrollData, CoinEarned, appChild: Child},
  data () {
    return {
      display: true,
      appShortName: process.env.APP_SHORT_NAME,
      showImageCaption: process.env.LEARN_IMAGE_CAPTION ? process.env.LEARN_IMAGE_CAPTION : false,
      appIcon: require('@/assets/logos/' + process.env.APP_ICON),
      deckId: parseInt(this.$route.params.deckId),
      groupId: parseInt(this.$route.params.groupId),
      apiUrl: process.env.API_URL,
      lastTimestamp: 0,
      isShowing: false,
      citationImageTitle: '',
      citationImageNote: '',
      citationDescriptionNote: '',
      citationCardName: '',
      citationViewName: '',
      citationDialog: false,
      // quickStartDialog: false,
      isChevronLeft: true,
      imageHeight: 250,
      scrollHeight: 0,
      steps: [
        {
          target: '#text-content-title',
          content: 'Just swipe from side to side to read through subjects.',
          params: {
            placement: 'bottom'
          }
        }, {

          target: '#leftHeaderId',
          content: 'Or jump to a particular subject using the icon',
          params: {
            placement: 'bottom'
          }
        }, {
          target: '#rightDrawerIcon',
          content: `You'll earn COINS as you read. Coins can be redeemed for PEEKS when answering questions in the quiz - to accelerate your learning!`,
          params: {
            placement: 'bottom'
          }
        }],
      myCallbacks: {
        onStart: this.tourOnStartCallback,
        onPreviousStep: this.tourPreviousStepCallback,
        onNextStep: this.tourNextStepCallback,
        onStop: this.tourStopCallback
      },
      currentStep: -1
    }
  },
  mounted: function () {
    this.scrollHeight = this.$store.getters.getAppHeight - 40

    if (this.$store.getters['getNewUserLoggedIn'] === true && this.$store.getters['getLearnStatus'] === true) {
      // this.quickStartDialog = true
      setTimeout(() => {
        this.$tours['learnTour'].start()
      }, 500)
    }
    this.$store.commit('user/recordTimeStart', 'Learn')
  },
  computed: {
    tourVal: {
      get: function () {
        return this.$route.query.learntour
      }
    },
    leftDrawer: {
      get: function () {
        return this.$store.getters.leftDrawer
      },
      set: function (value) {
        this.$store.commit('toggleLeftDrawer', value)
      }
    },
    navigationData () {
      return this.$store.getters['learn/getFolders']
    },
    viewCount: {
      get: function () {
        return parseInt(this.$route.params.viewCount)
      },
      set: function (e1) {
      }
    },
    currentLevel: {
      get: function () {
        return parseInt(this.$route.params.level)
      },
      set: function () {
        // setting db object
      }
    },
    appHeight: {
      get: function () {
        return this.scrollHeight
      },
      set: function (height) {
        this.scrollHeight = height
      }
    },
    styleObj () {
      const height = this.appHeight
      return {
        'height': height + 'px!important',
        'overflow': 'auto'
      }
    },
    // windowHeight: function () {
    //   return window.innerHeight - 10
    // },
    viewId: {
      get: function () {
        return this.$store.getters['learn/getViewId']
      },
      set: function (value) {
        this.$store.commit('learn/setViewId', value)
      }
    },
    cardId: {
      get: function () {
        return this.$store.getters['learn/getCardId']
      },
      set: function (value) {
        this.$store.commit('learn/setCardId', value)
      }
    },
    tokens: {
      get: function () {
        return parseInt(this.group.tokens)
      },
      set: function () {
      }
    },
    e1: {
      get: function () {
        return parseInt(this.$route.params.viewCount)
      },
      set: function () {
      }
    },
    levels () {
      return this.$store.getters['learn/getFolders']
    },
    currentLevelName () {
      return this.navigationData.find(level => level.level_number === this.currentLevel).name
    },
    views () {
      return this.$store.getters['learn/getAllViews']
    },
    group: {
      get: function () {
        return this.$store.getters['course/getGroups'].find(group => parseInt(group.groupId) === this.groupId)
      },
      set: function () {
      }
    }
  },
  methods: {
    goToHome () {
      this.leftDrawer = !this.leftDrawer
      this.$router.push({name: 'Home'})
    },
    getCardDetails (cardId, levelId) {
      const level = this.navigationData.find(levels => levels.level_number === levelId)
      return level.cards.find(card => card.card_id === cardId)
    },
    getViewPaging (cardId, viewId, levelId) {
      const level = this.navigationData.find(levels => levels.level_number === levelId)
      const card = level.cards.find(card => card.card_id === cardId)
      const view = card.views.find(view => view.view_id === viewId)
      return `${view.viewsCountInLevel} of ${level.viewsCountInLevel}`
    },
    levelImage (levelNumber) {
      return require(`@/assets/images/level_icons_light_gray/Level${levelNumber}LtGray.png`)
    },
    levelHeaderImage (levelNumber) {
      return require(`@/assets/images/level_icons/${levelNumber}.svg`)
    },
    tourOnStartCallback (currentStep) {
      this.currentStep = 0
      // console.log('currentStep', this.currentStep)
    },
    tourPreviousStepCallback (currentStep) {
      this.currentStep = this.currentStep - 1
      // console.log('currentStep', this.currentStep)
    },
    tourNextStepCallback (currentStep) {
      this.currentStep = this.currentStep + 1
      // console.log('currentStep', this.currentStep)
    },
    tourStopCallback (currentStep) {
      this.currentStep = -1
      this.$store.commit('setLearnStatus', false)
      this.$router.replace({ query: { learntour: 'end' } })
    },
    isCardActive (card) {
      return (this.viewCount >= card.minViewCount && this.viewCount <= card.maxViewCount)
    },
    getCardImage (resourceurl) {
      const image = typeof resourceurl.imageResource === 'undefined' ? '' : resourceurl.imageResource.resourceurl
      if (image) {
        return (`${process.env.API_URL}/ws/playerservice${image}`)
      } else {
        return 'static/images/cards.png'
      }
    },
    closeListGroup () {
      // console.log('closeListGroup...')
      this.listGroup = false
    },
    learnTourStyleObj () {
      return {
        width: this.$store.getters.getAppWidth + 'px',
        height: '20px',
        top: '350px',
        position: 'fixed',
        margin: '0 auto'
      }
    },
    rightNavTourCoinObj () {
      return {
        width: this.$store.getters.getAppWidth + 'px',
        height: '20px',
        top: '100px',
        position: 'fixed',
        right: '0'
      }
    },
    textContentStyleObject () {
      // const breakpoint = this.$vuetify.breakpoint.name
      let height = (this.appHeight - this.imageHeight - 50) + 'px'
      // console.log('height', height)
      return {
        height,
        'padding-bottom': '10px'
      }
    },
    swipe (direction) {
      if (direction === 'Left') {
        this.nextSlide()
      } else if (direction === 'Right') {
        this.prevSlide()
      }
    },
    // closeQuickStartDialog () {
    //   this.quickStartDialog = false
    //   this.$store.commit('setLearnStatus', false)
    // },
    openCitation (view) {
      this.citationDialog = true
      this.citationImageTitle = view.imageResource.caption
      this.citationImageNote = view.imageResource.headers
      this.citationDescriptionNote = view.textResource.headers
      this.citationCardName = ''
      this.citationViewName = view.title
    },
    toggleShow () {
      this.isShowing = true
      this.isChevronLeft = false
      setTimeout(() => {
        this.isShowing = false
      }, 100)
      setTimeout(() => {
        this.isChevronLeft = true
      }, 2500)
    },
    // getImage (img) {
    //   return require(img)
    // },
    nextSlide () {
      if (this.views.length !== this.e1) {
        const view = this.views.find(data => data.viewCount === this.e1)
        this.viewId = view.view_id
        this.cardId = view.card_id
        const allParams = {...this.$store.getters['learn/getLastLearnRoute']}
        const params = {groupId: this.groupId, level: view.nextLevel, deckId: this.deckId, viewCount: this.e1 + 1}
        allParams[view.nextLevel] = params
        this.$store.commit('learn/setLastLearnRoute', allParams)
        this.$router.push({
          name: 'Learn',
          params
        })
      }
    },
    prevSlide () {
      if (this.e1 !== 1) {
        const view = this.views.find(data => data.viewCount === this.e1)
        this.viewId = view.view_id
        this.cardId = view.card_id
        const allParams = {...this.$store.getters['learn/getLastLearnRoute']}
        const params = {groupId: this.groupId, level: view.previousLevel, deckId: this.deckId, viewCount: this.e1 - 1}
        allParams[view.nextLevel] = params
        this.$store.commit('learn/setLastLearnRoute', allParams)
        this.$router.push({
          name: 'Learn',
          params
        })
      }
    }
  },
  watch: {
    tourVal (newVal) {
      setTimeout(() => {
        if (newVal === 'start') {
          this.$tours['learnTour'].start()
        }
      }, 500)
    },
    viewCount (e1) {
      const view = this.views.find(data => data.viewCount === e1)
      this.$store.commit('learn/setViewId', view.view_id)
      this.$store.commit('learn/setCardId', view.card_id)
    },
    e1 (newVal) {
      this.lastTimestamp = Math.floor(Date.now() / 1000)
      setTimeout(() => {
        const currTimeStamp = Math.floor(Date.now() / 1000)
        const lastTime = this.lastTimestamp
        if ((currTimeStamp - lastTime) === 3) {
          const t1 = toTimestamp(this.group.scheduleStartDate)
          const t2 = Math.floor(Date.now() / 1000)
          const state = t2 - t1
          const content = {
            'data': [{'id': this.cardId, 'type': 1, 'views': [{'id': this.viewId, 'state': state}]}],
            'activityCounter': this.group.activityCounter
          }
          this.$store.dispatch('course/setGameReadState', {content, memberId: this.group.memberId, sessionId: this.group.sessionId, groupId: this.groupId})
        }
      }, 3000)
    },
    currentStep (newVal) {
      if (newVal === 2) {
        this.toggleShow()
        // this.$store.commit('toggleRightDrawer', true)
      }
    },
    tokens (newVal) {
      this.$store.commit('flashSuccess', 'You earned a coin!')
      this.toggleShow()
    },
    currentLevel () {
      this.display = !this.display
      setTimeout(() => {
        this.display = !this.display
      }, 1000)
    }
  },
  destroyed () {
    this.$store.commit('user/recordTimeEnd', 'Learn')
  }
}
</script>
<style scoped>
  @mixin ballb($yaxis: 0) {
    transform: translate3d(0, $yaxis, 0);
  }

  .ball {
    width: 60px;
    height: 60px;
    background: url("http://safefoodhandler.cogneti.com/static/img/coin.svg");
    transform-origin: 50% 50%;
    transform: translate3d(0, -1000px, 0) rotate(0);
    z-index: 9999!important;
  }

  @keyframes rollout {
    0% { transform: translate3d(0, 300px, 100px) rotateY(0);}
    50% { transform: translate3d(-10, 100px, 100px) rotateY(0);}
    100% { transform: translate3d(0, 0px, 0) rotateY(0);opacity: 0;
    }
  }

  @keyframes ballroll {
    0% { transform: rotateY(0); }
    100% { transform: rotateY(1000deg)}
  }

  .ballmove-enter {
    bottom: 0;
    position: fixed;
  @include ballb(600px);
  }

  .ballmove-enter-active, .ballmove-leave-active  {
    z-index: 9999!important;
    width: 60px;
    height: 60px;
    margin-left: 20px;
    animation: ballroll 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .ballmove-enter div {
    z-index: 9999!important;
    animation: rollout 3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .ballmove-leave-to div {
    z-index: 9999!important;
    animation: rollout 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .sfh-login-form{
    padding-top: 0!important;
  }
</style>
<style>
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Learn.vue